import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import defaultTexts from '../../../texts/texts'
import PaymentMethodsEditItem from './PaymentMethodsEditItem'

const PaymentMethodsEdit = (props) => {
  const { availablePaymentMethods, paymentMethods, setFetchAccountConfigs } = props
  const theme = useTheme()

  const descriptionStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
    paddingBottom: '20px',
  }

  return (
    <>
      <Box sx={descriptionStyle}>{defaultTexts.paymentMehotdsSupportingSelectedCurrency}</Box>
      {
        availablePaymentMethods.map((item, index) => (
          <PaymentMethodsEditItem
            key={index}
            {...item}
            paymentMethods={paymentMethods}
            setFetchAccountConfigs={setFetchAccountConfigs}
          />
        ))
      }   
    </>
  )
}

export default PaymentMethodsEdit